import axios from 'axios'
import { alert } from "devextreme/ui/dialog"
const baseUri = "WebApi.asmx/api/ResourceTypeService";
const store = {};
const mutations = {

    SET_RESOURCE_TYPE_LIST(state, posts) {
        state.resourceTypeList = posts;
        state.resourceTypeListIsLoading = false;
    },
    GET_DETAIL(state, posts) {
        if (posts.success == true) {
            state.resourceTypeDetail = posts.data;
            state.resourceTypeDetailChanged = false;
        }
        else {
            alert(posts.errorMessage);
        }
    },
    SAVE_DETAIL(state, posts) {
        if (posts.success == true) {
            state.resourceTypeDetailChanged = false;
        }
        else {
            alert(posts.errorMessage);
        }
    },
};
const state = {
    resourceTypeListIsLoading: false,
    resourceTypeList: [],
    resourceTypeDetail: {},
    resourceTypeDetailChanged: false
};
const getters = {};
const actions = {

    getResourceTypeList({ commit }) {
        state.resourceTypeListIsLoading = true;
        axios
            .get(baseUri + '/GetList')
            .then(res => {
                if (res.data.success == true) {
                    commit('SET_RESOURCE_TYPE_LIST', res.data.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
    getResourceTypeDetail({ commit }, data) {
        state.resourceTypeListIsLoading = true;
        var formData = new FormData();
        formData.append("rtyID", data.rtyId);
        axios
            .post(baseUri + '/GetDetail', formData)
            .then(res => {
                if (res.data.success == true) {
                    commit('GET_DETAIL', res.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
    saveResourceTypeDetail({ commit }) {
        var formData = new FormData();
        formData.append("data", JSON.stringify(state.resourceTypeDetail));
        axios
            .post(baseUri + '/SaveDetail', formData)
            .then(res => {
                if (res.data.success == true) {
                    commit('SAVE_DETAIL', res.data);
                } else {
                    alert("An error occured while updating: " + res.data.errorMessage);
                }
            });
    }
};


export default {
    state,
    store,
    mutations,
    getters,
    actions
}